import React from 'react'

import { Button, Icon } from '../../../module'
import styles from '../_menu.module.scss'
import { type MenuActionPropsBase } from '../Menu'
import SingleCsv from '../../CsvExport/SingleCsv'

type SingleCsvProps = React.ComponentProps<typeof SingleCsv>

type MenuCsvRowProps = SingleCsvProps & {
  destructive?: boolean
  className: string
  disabled?: MenuActionPropsBase['disabled']
  close?: () => void
  handleCsvAction?: (value: boolean) => void
  setLoading?: (value: boolean) => void
  loading?: boolean
}

const MenuCsvRow = ({
  csv,
  className,
  disabled,
  close,
  setLoading,
  loading,
  destructive,
  handleCsvAction,
  qaTestId,
}: MenuCsvRowProps) => {
  return (
    <div className={styles.menuRow}>
      <Button
        as='unstyled'
        className={className}
        disabled={disabled?.value}
        onClick={(e) => {
          e.stopPropagation()
          close?.()
        }}
        {...(disabled?.tooltip ? { tooltip: disabled?.tooltip } : {})}
        qaTestId={qaTestId}
      >
        <span className={styles.iconAndName}>
          <Icon
            icon='download'
            color={destructive ? 'dark-red' : 'purple'}
            iconSize='16px'
          />
          <SingleCsv
            csv={csv}
            key={csv.linkName}
            csvId={csv.linkName}
            hideIcon
            setLoading={setLoading}
            handleCsvAction={handleCsvAction}
            loading={loading}
          />
        </span>
      </Button>
    </div>
  )
}

export default MenuCsvRow
